import React from "react";

import { linkifyText } from "../../utils/businessSheetUtils";

const PortfolioDisplay = ({ items, title }) => (
  <section className="portfolioDisplay">
    {title && <h3 className="portfolioDisplay__title">{title}</h3>}
    <div className="portfolio-grid">
      {items.map((item, i) => (
        <div key={i} className="portfolio-card">
          {item.imageUrl && (
            <img src={item.imageUrl} alt={item.title} className="portfolio-card__image" />
          )}
          <h4 className="portfolio-card__title">{item.title}</h4>
          <p className="portfolio-card__description">{linkifyText(item.description, i)}</p>
        </div>
      ))}
    </div>
  </section>
);

export default PortfolioDisplay;
